


import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom/dist";
import PropTypes from "prop-types";
import { Table, InputNumber, Spin } from "antd";
import { Payroll_API_BASE_URL } from "../PConfig/PConfig";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import SalaryTypeBadge from "./Salarybadge";

const EditCTC = ({ editObj, onCtcUpdated }) => {
  const navigate = useNavigate();
  const [tokenData, setTokenData] = useState(null);
  const [salaryList, setSalaryList] = useState([]);
  const [orgSalaryId, setOrgSalaryId] = useState(null);
  const [effectiveDate, setEffectiveDate] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [RegId, setRegId] = useState(null);
  const [hystryList, setHystryList] = useState([]);


  useEffect(() => {
    if (editObj?.OrgSalId) {
      setOrgSalaryId(editObj.OrgSalId);
      setEffectiveDate(editObj.EffectiveDate ? dayjs(editObj.EffectiveDate) : null);
    }
  }, [editObj]);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("PayrollSuperId");

    if (token && superId) {
      setTokenData(token);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (!tokenData || !RegId) return;

    const fetchHistoryList = async () => {
      const params = new URLSearchParams({
        RegId: RegId,
      });
      setDataLoading(true);
      try {
        const response = await fetch(
          `${Payroll_API_BASE_URL}payroll/EmployeCTC/GetEmpCtcHistory?${params.toString()}`,
          {
            headers: {
              "Content-Type": "application/json",
              // Authorization: `Bearer ${tokenData}`,
              Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch setHystry List");
        }

        const data = await response.json();

        if (data?.status) {
          setHystryList(data.ResultData || []);
        } else {
          console.error("Invalid API response:", data);
          setHystryList([]);
        }
      } catch (error) {
        console.error("Error fetching setHystry List:", error);
        setHystryList([]);
      }
      finally {
        setDataLoading(false);
      }
    };

    fetchHistoryList();
  }, [tokenData, RegId]);

  useEffect(() => {
    if (!tokenData || !orgSalaryId) return;

    const fetchSalaryList = async () => {
      const params = new URLSearchParams({
        OrgSalaryId: orgSalaryId,
      });
      setDataLoading(true);
      try {
        const response = await fetch(
          `${Payroll_API_BASE_URL}payroll/EmployeCTC/GetctcdetailsForEmp?${params.toString()}`,
          {
            headers: {
              "Content-Type": "application/json",
              // Authorization: `Bearer ${tokenData}`, 
              Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
            },
          }
        );

        if (!response.ok) throw new Error("Failed to fetch CTC details");

        const data = await response.json();

        if (data?.status && data.ResultData) {
          setSalaryList(
            data.ResultData.map((item, index) => ({
              ...item,
              key: item.SalaryHeadsId || index + 1,
            }))
          );
        } else {
          setSalaryList([]);
        }
      } catch (error) {
        Swal.fire("Error fetching CTC details:", error);
        setSalaryList([]);
      } finally {
        setDataLoading(false);
      }
    };

    fetchSalaryList();
  }, [tokenData, orgSalaryId]);

  useEffect(() => {
    if (editObj?.EffectiveDate) {
      const dateStr = dayjs(editObj.EffectiveDate).format("YYYY-MM-DD");
      if (dateStr !== "Invalid Date") {
        setEffectiveDate(dateStr);
      }
    }
    if (editObj) {
      setOrgSalaryId(editObj.OrgSalId);
      setRegId(editObj.RegId);
    }
  }, [editObj]);


  const handleSalaryChange = (key, value) => {
    setSalaryList((prev) =>
      prev.map((item) =>
        item.key === key ? { ...item, Amount: value || 0 } : item
      )
    );
  };

  const handleDelete = (key) => {
    setSalaryList((prev) => prev.filter((item) => item.key !== key));
  };

  const monthlyCTC = salaryList.reduce((sum, item) => sum + (Number(item.Amount) || 0), 0);
  const yearlyCTC = monthlyCTC * 12;

  const handleSave = async () => {
    if (!orgSalaryId || !effectiveDate) {
      Swal.fire("Missing OrgSalaryId or Effective Date");
      return;
    }

    const payload = {
      SuperId: editObj?.SuperId,
      RegId: editObj?.RegId,
      MonthlyCTC: monthlyCTC,
      AnnualCTC: yearlyCTC,
      CreatedBy: editObj?.SuperId || null,
      OrgSalaryId: orgSalaryId,
      EffectiveDate: effectiveDate,
      EmpCtc: salaryList.map((item) => ({
        SalaryHeadId: item.SalaryHeadsId || item.SalaryHeadId,
        Amount: Number(item.Amount) || 0,
      })),
    };

    setSaving(true);
    try {
      const response = await fetch(
        `${Payroll_API_BASE_URL}payroll/EmployeCTC/UpdateEmpCtc`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${tokenData}`,
            Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (response.ok && result?.status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Employee CTC added successfully",
          confirmButtonText: "OK",
        }).then(() => {
          onCtcUpdated?.();
          document.querySelector('[data-bs-dismiss="offcanvas"]')?.click();
        });
      } else {
        Swal.fire("Update failed: " + (result?.message || "Unknown error"));
      }
    } catch (err) {
      console.error("Save error:", err);
      Swal.fire("Error while saving: " + err.message);
    } finally {
      setSaving(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const salaryTypeMap = {
    Basic: "Earning",
    HRA: "Earning",
    Conveyance: "Earning",
    Medical: "Earning",
    Special: "Earning",
    Incentive: "Earning",
    OT: "Earning",
    Bonus: "Earning",
    PF: "Deduction",
    ESI: "Deduction",
    Tax: "Deduction",
    PT: "Deduction",
    Advance: "Deduction",
    "Loss Of Pay": "Deduction",
  };
  const earningList = salaryList.filter(
    (item) => salaryTypeMap[item.SalaryHeadsName] === "Earning"
  );

  const deductionList = salaryList.filter(
    (item) => salaryTypeMap[item.SalaryHeadsName] === "Deduction"
  );
  const columns = [
    {
      title: "Salary Head",
      dataIndex: "SalaryHeadsName",
      key: "SalaryHeadsName",
      // align: "center",
      ellipsis: true,
      width: "38%",
    },
    // {
    //   title: "Type",
    //   key: "Type",
    //   // align: "center",
    //   width: "33%",
    //   render: (_, record) => {
    //     const type = salaryTypeMap[record.SalaryHeadsName] || "Earning";
    //     return (
    //       <span
    //         style={{
    //           color: type === "Deduction" ? "red" : "green",
    //           fontWeight: 600,
    //         }}
    //       >
    //         {type}
    //       </span>
    //     );
    //   },
    // },
    {
      title: "Amount (₹)",
      dataIndex: "Amount",
      key: "Amount",
      // align: "center",
      width: "38%",
      render: (_, record) => (
        <InputNumber
          size="small"
          min={0}
          style={{ width: "100%" }}
          value={record.Amount || 0}
          formatter={(value) =>
            value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value.replace(/,/g, "")}
          onChange={(value) => handleSalaryChange(record.key, value)}
        />
      ),
    },
    {
      title: "Action",
      key: "action",
      width: 40,
      align: "center",
      render: (_, record) => (
        <span
          style={{ color: "red", cursor: "pointer", fontWeight: "bold" }}
          onClick={() => handleDelete(record.key)}
        >
          ✖
        </span>
      ),
    },
  ];


  const historyColumns = [
    {
      title: "Revised On",
      dataIndex: "CreatedOn",
      // align: "center",
      render: (val) => formatDate(val),
    },
    {
      title: "Monthly (₹)",
      dataIndex: "MonthlyCTC",
      render: (val) => `₹${val.toLocaleString("en-IN")}`,
    },
    {
      title: "Yearly (₹)",
      dataIndex: "AnnualCTC",
      render: (val) => `₹${val.toLocaleString("en-IN")}`,
    },
    // {
    //   title: "Revised by",
    //   dataIndex: "revisedBy",
    // },
  ];

  if (!editObj) return null;

  return (
    <div>
      <style>
        {`
          .ctc-table .ant-table-thead > tr > th {
            background-color: #d2e6f5ff !important;
          }
          .ctc-info-2col {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            column-gap: 20px;
            row-gap: 8px;
            margin-bottom: 16px;
          }
          .ctc-pair {
            display: flex;
            align-items: center;
            font-size: 16px;
          }
          .ctc-label {
            min-width: 80px;
            font-weight: 600;
          }
          .ctc-value {
            font-weight: 500;
          }
            .ctc-date-wrapper {
  display: flex;
  align-items: center;
}

.ctc-date-input {
  margin-left: 6px;
  height: 32px;
  width: 160px;
  font-size: 14px;
  padding: 2px 6px;
}

        `}
      </style>

      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightEditCTC"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: "45%", maxWidth: "45%" }}
      >
        <div className="offcanvas-header my-0 py-3">
          <h4 id="offcanvasRightLabel" className="mb-0">
            {/* Edit Employee Annual CTC */}
            Edit {editObj?.UserName}&apos;s Salary Details
          </h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>

        <hr className="my-1" />

        <div className="offcanvas-body px-3">
          {/* Employee Info */}
          <div className="mb-3 fs-16 row">
            {/* <div className="col-8 row mb-2">
              <span className="col-3">Employee</span>
              <span className="col-9">: {editObj.UserName}</span>
            </div> */}
            <div className="col-6 row mb-2">
              <span className="col-3">Badge</span>
              <span className="col-9">: {editObj?.Badge}</span>
            </div>
            {/* <div className="col-4">
              <span className="">Badge</span>
              <span className="">: {editObj.Badge}</span>
            </div> */}
            <div className="col-6 row">
              <span className="col-3">Branch</span>
              <span className="col-9">: {editObj?.Branch}</span>
            </div>
          </div>

          {/* Editable Salary Table */}
          {dataLoading ? (
            <div className="text-center my-4">
              <Spin size="large" />
              <p>Loading data...</p>
            </div>
          ) : (
            // <Table
            //   columns={columns}
            //   className="ctc-table"
            //   dataSource={salaryList}
            //   pagination={false}
            //   bordered
            //   size="small"
            //   tableLayout="fixed"
            // />
            <div style={{ display: "flex", gap: "15px", marginTop: "10px" }}>
              <div style={{ flex: 1 }}>
                <h5 style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                  <SalaryTypeBadge type="Earning" />
                  Earnings
                </h5>
                <Table
                  columns={columns}
                  dataSource={earningList}
                  className="ctc-table1"
                  pagination={false}
                  size="small"
                  bordered
                />
              </div>

              <div style={{ flex: 1 }}>
                <h5 style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                  <SalaryTypeBadge type="Deduction" />
                  Deductions
                </h5>
                <Table
                  columns={columns}
                  dataSource={deductionList}
                  className="ctc-table1"
                  pagination={false}
                  size="small"
                  bordered
                />
              </div>
            </div>
          )}

          <div className="mt-2 mb-2">
            <div
              className="bg-light p-3 border rounded"
              style={{ fontSize: '1rem' }}
            >
              {/* Monthly & Annual - same row */}
              <div className="row align-items-center mb-3">
                <div className="col-6">
                  <span className="me-2 text-nowrap">Monthly :</span>
                  <span className="text-primary fw-semibold">
                    ₹{monthlyCTC.toLocaleString('en-IN')}
                  </span>
                </div>

                <div className="col-6">
                  <span className="me-2 text-nowrap">Annual :</span>
                  <span className="text-success fw-semibold">
                    ₹{yearlyCTC.toLocaleString('en-IN')}
                  </span>
                </div>
              </div>

              {/* Revised On - bottom single line */}
              <div className="d-flex align-items-center">
                <span className="me-2 text-nowrap">Revised On :</span>
                <input
                  type="date"
                  className="form-control"
                  style={{ width: '165px', height: '38px' }}
                  value={effectiveDate || ''}
                  onChange={(e) => setEffectiveDate(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end gap-2 mt-4">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="offcanvas"
              disabled={saving}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSave}
              disabled={saving || dataLoading}
            >
              {saving ? "Saving..." : "Save Changes"}
            </button>
          </div>

          <hr className="my-3" />
          <h5 className="mb-2">Increment History</h5>
          {dataLoading ? (
            <div className="text-center my-4">
              <Spin size="large" />
              <p>Loading data...</p>
            </div>
          ) : (
            <Table
              columns={historyColumns}
              className="ctc-table px-5"
              dataSource={hystryList}
              pagination={false}
              size="small"
              bordered
            />
          )}
        </div>
      </div>
    </div>
  );
};

EditCTC.propTypes = {
  editObj: PropTypes.shape({
    OrgSalId: PropTypes.number.isRequired,
    UserName: PropTypes.string.isRequired,
    Badge: PropTypes.string,
    Branch: PropTypes.string,
    MonthlyCTC: PropTypes.number,
    AnnualCTC: PropTypes.number,
    EffectiveDate: PropTypes.string,
    SuperId: PropTypes.number,
    RegId: PropTypes.number,
    CreatedBy: PropTypes.string
  }).isRequired,
  onCtcUpdated: PropTypes.func,
};

export default EditCTC;